/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TJoin, TModule, TNonEmptyArray, TRole, TRoleClaim, TTenant, TUser, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_Role, ListCommandResult_Role } from "../../helpers/types.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TRole
  | TJoin<"tenant", TTenant>
  | TJoin<"module", TModule>
  | TJoin<"userRoles", TUserRole>
  | TJoin<"userRoles.user", TUser>
  | TJoin<"roleClaims", TRoleClaim>;

type TRoleByIdFunctions = { getByID: CommandResult_Role }
export type TRoleByIdQueries = { role: TRoleByIdFunctions };
export const roleById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleById($id: Guid!) {
    role {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Role")}
`;

type TRoleAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_Role }
export type TRoleAllWithPaginationQueries = { role: TRoleAllWithPaginationFunctions };
export const roleAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    role {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Role")}
`;

type TRoleAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_Role }
export type TRoleAllWithSortedPaginationQueries = { role: TRoleAllWithSortedPaginationFunctions };
export const roleAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query roleAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    role {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_Role")}
`;